// id - cetagory number
const mockTestList = [
  {
    id: 1,
    title: "Mock Test 01",
    iconName: "alertness_icon.png",
  },
  {
    id: 2,
    title: "Mock Test 02",
    iconName: "alertness_icon.png",
  },
  {
    id: 3,
    title: "Mock Test 03",
    iconName: "alertness_icon.png",
  },
  {
    id: 4,
    title: "Mock Test 04",
    iconName: "alertness_icon.png",
  },
  {
    id: 5,
    title: "Mock Test 05",
    iconName: "alertness_icon.png",
  },
];

export default mockTestList;
